import { useState, useEffect } from 'react';
import { ReactComponent as ImagePlayPlus } from '../../public/images/svg/ImagePlayPlus.svg';
import { deviceHasCamera } from '../Utils/deviceUtils';
import { ElementDetacher } from '../Controls/ElementDetacher';
import { DockPanelHandle } from '../Controls/DockPanel/DockPanel';
import { SkitterBookVideoFileLoader } from './SkitterBookVideoFileLoader';
import { OnVideoFileLoadProps } from '../Models/SkitterbookOnVideoFileLoadProps';
import './css/SkitterBookLoader.css';

export interface SkitterBookOnLoadProps {
    videoBuffer: ArrayBuffer;
    videoName: string;
}

export interface SkitterbookLoaderProps {
    skitterbookId: string | null;
    videoBuffer: ArrayBuffer | null;
    dockPanel: React.RefObject<DockPanelHandle | null>;
    onLoad: (result: SkitterBookOnLoadProps) => void;
}

export const SkitterBookLoader: React.FC<SkitterbookLoaderProps> = ({ skitterbookId, videoBuffer, dockPanel, onLoad }) => {

    useEffect(() => {
        deviceHasCamera().then(hasCam => {
            //setCanRecordVideo(hasCam);
        });
    }, []);

    const startSkitterbookContent = <div className={`start-skitterbook-title-content`}>
        <div className="start-skitterbook-title">{`${skitterbookId != null || videoBuffer != null ? "Begin another Skitterbook" : "Start Your Skitterbook"}`}</div>
        <div className="start-skitterbook-subtitle">{"Upload a video to create your own personalised flipbook"}</div>
        <ImagePlayPlus height="100%" width="100%" viewBox="0 0 28 20" />
    </div>

    const reducedStartSkitterbookContent = <div className={`start-skitterbook-title-content reduced`}>
        <ImagePlayPlus height="100%" width="100%" viewBox="0 0 28 20" />
    </div>

    const onVideoFileLoadHandler = (props: OnVideoFileLoadProps) => {
        onLoad({ videoBuffer: props.videoBuffer, videoName: props.videoName });
    }

    const reducedFileLoaderContent = <SkitterBookVideoFileLoader skitterbookId={skitterbookId}
        tooltipText={`${skitterbookId != null || videoBuffer != null ? 'Begin a new Skitterbook' : 'Select a video file'}`}
        titleContent={reducedStartSkitterbookContent}
        onVideoFileLoad={onVideoFileLoadHandler} />;

    return (
        <div className={`skitterbook-loader-container ${videoBuffer !== null ? 'loaded' : ''}`}>
            <ElementDetacher id="skitterbook-loader-scroll-detacher"
                dockPanel={dockPanel}
                mustDock={skitterbookId != null || videoBuffer != null}
                alternativeContent={reducedFileLoaderContent} >
                <SkitterBookVideoFileLoader skitterbookId={skitterbookId}
                    titleContent={startSkitterbookContent}
                    onVideoFileLoad={onVideoFileLoadHandler} />
            </ElementDetacher>
        </div>
    );
};
